import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/textbooksolution" }, "/textbooksolution", -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" please visit "),
    _hoisted_2
  ]))
}